import styled from "styled-components";

export const NavigationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 50px;
  position: fixed;
  bottom: 0;
  height: 80px;
  width: 100%;
  background: white;
  z-index: 3;
`;

export const BackButton = styled.button`
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  display: inline-flex;
  height: 40px;
  padding: 11px 17px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out;
  background: ${({ theme }) => theme.colors.campaignCreationNavigation.backButtonBgColor};
  color: ${({ theme }) => theme.colors.campaignCreationNavigation.backButtonTextColor};
  border-radius: 4px;
  border: ${({ theme }) =>
    `1px solid ${theme.colors.campaignCreationNavigation.backButtonBorderColor}`};
  min-width: max-content;

  &:hover {
    background: ${({ theme }) => theme.colors.campaignCreationNavigation.backButtonHoverBgColor};
    color: ${({ theme }) => theme.colors.campaignCreationNavigation.backButtonHoverTextColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.backButtonHoverBorderColor}`};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.campaignCreationNavigation.backButtonDisabledBgColor};
    color: ${({ theme }) => theme.colors.campaignCreationNavigation.backButtonDisabledTextColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.backButtonDisabledBorderColor}`};
  }
`;

export const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 15px;
  width: max-content;
`;

export const DrafButton = styled.button`
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  display: inline-flex;
  height: 40px;
  padding: 11px 17px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out;
  background: ${({ theme }) => theme.colors.campaignCreationNavigation.saveDraftButtonBgColor};
  color: ${({ theme }) => theme.colors.campaignCreationNavigation.saveDraftButtonTextColor};
  border-radius: 4px;
  border: ${({ theme }) =>
    `1px solid ${theme.colors.campaignCreationNavigation.saveDraftButtonBorderColor}`};
  min-width: max-content;

  &:hover {
    background: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.saveDraftButtonHoverBgColor};
    color: ${({ theme }) => theme.colors.campaignCreationNavigation.saveDraftButtonHoverTextColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.saveDraftButtonHoverBorderColor}`};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.saveDraftButtonDisabledBgColor};
    color: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.saveDraftButtonDisabledTextColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.saveDraftButtonDisabledBorderColor}`};
  }
`;

export const ContinueButton = styled.button`
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  display: inline-flex;
  height: 40px;
  padding: 11px 17px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out, border 0.3s ease-in-out;
  border-radius: 4px;
  min-width: max-content;

  background: ${({ theme }) => theme.colors.campaignCreationNavigation.continueButtonBgColor};
  color: ${({ theme }) => theme.colors.campaignCreationNavigation.continueButtonTextColor};
  border: ${({ theme }) =>
    `1px solid ${theme.colors.campaignCreationNavigation.continueButtonBgColor}`};

  &:hover {
    background: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.continueButtonHoverBgColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.continueButtonHoverBgColor}`};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.continueButtonDisabledBgColor};
    color: ${({ theme }) =>
      theme.colors.campaignCreationNavigation.continueButtonDisabledTextColor};
    border: ${({ theme }) =>
      `1px solid ${theme.colors.campaignCreationNavigation.continueButtonDisabledBorderColor}`};
  }
`;
